import classes from '../../api/classes'
import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'
import HttpRouter from '../../services/HttpRouter'

const state = {
    classes: [],
    loading: true,
    error: false,
}

const actions = {
    [action_types.CLASSES_LOAD](context, { schoolId }) {
        return new Promise((resolve, reject) => {
            context.commit(mutation_types.CLASSES_LOADING, { loading: true })

            classes.getClasses({ schoolId }, loaded_classes => {
                context.commit(mutation_types.CLASSES_SET, { classes: loaded_classes })
                context.commit(mutation_types.CLASSES_LOADING, { loading: false })
                resolve(loaded_classes)
            }, error => {
                context.commit(mutation_types.CLASSES_LOADING, { loading: false })
                context.commit(mutation_types.CLASSES_ERROR_SET, { error })
                reject(error)
            })
        })
    },

    [action_types.CLASSES_ADD_NEW](context, { schoolId, classObject }) {
        const isCustomSubject = classObject.custom_subject && !classObject.subject_id

        return new Promise((resolve, reject) => {
            classes.addClass({ schoolId, classObject }).then(newClass => {
                context.dispatch(action_types.CLASSES_LOAD, { schoolId: schoolId })
                    .then(() => {
                        const createdClass = context.state.classes
                            .find((c) => c.name === classObject[0].name)

                        if (!createdClass) {
                            throw new Error('created class cannot be found!')
                        }

                        HttpRouter.post(null, `school/${schoolId}/classes/${createdClass.id}/students`, {
                            num_students: classObject[0].num_students
                        }).then(() => {
                            context.dispatch(action_types.CLASSES_LOAD, { schoolId: schoolId })
                            resolve()
                        })
                    })

                if (isCustomSubject) context.commit(mutation_types.SUBJECTS_ADD, { subject: classObject.subject.data })
            }, errors => {
                addEdNotification(errors, 'error')

                reject(errors)
            })
        })
    },

    [action_types.CLASSES_SAVE](context, { schoolId, classObject }) {
        const isCustomSubject = classObject.custom_subject && !classObject.subject_id

        const classInState = context.state.classes
            .find((c) => c.id === classObject.id)

        if (!classInState) {
            throw new Error('viss slikti')
        }

        if (
            classInState.name === classObject.name &&
            classInState.num_students === classObject.num_students &&
            classInState.teacher_id === classObject.teacher_id
        ) {
            return Promise.resolve()
        }

        return new Promise((resolve, reject) => {
            const promises = []

            if (classInState.name !== classObject.name || classInState.teacher_id !== classObject.teacher_id) {
                promises.push(classes.updateClass({ schoolId, classObject }))
            }

            if (classInState.num_students !== classObject.num_students) {
                promises.push(HttpRouter.post(null, `school/${schoolId}/classes/${classInState.id}/students`, {
                    num_students: classObject.num_students
                }))
            }

            Promise.all(promises)
                .then(() => {
                    if (isCustomSubject) {
                        context.commit(mutation_types.SUBJECTS_ADD, { subject: classObject.subject.data })
                    }

                    context.dispatch(action_types.CLASSES_LOAD, { schoolId: schoolId }).then(resolve)
                })
                .catch((errors) => {
                    console.log(errors)
                    addEdNotification(errors, 'error')
                    reject(errors)
                })
        })
    },

    [action_types.CLASSES_DELETE](context, { schoolId, classObject }) {
        classes.deleteClass({ schoolId, classObject }, () => {
            context.commit(mutation_types.CLASSES_DELETE, { classObject: classObject })
        })
    }
}

const mutations = {
    [mutation_types.CLASSES_SET](state, { classes }) {
        state.classes = classes
    },

    [mutation_types.CLASSES_LOADING](state, { loading }) {
        state.loading = loading
    },

    [mutation_types.CLASSES_ERROR_SET](state, { error }) {
        state.error = error
    },

    [mutation_types.CLASSES_ADD](state, { classObject }) {
        state.classes.push(classObject)
    },
    [mutation_types.CLASSES_DELETE](state, { classObject }) {
        state.classes.splice(classObject.index, 1)
    },

    [mutation_types.CLASSES_UPDATE](state, { classObject }) {
        for (var i = 0; i < state.classes.length; i++) {
            if (state.classes[i].id == classObject.id) {
                state.classes[i] = classObject
            }
        }
    }
}

export default {
    state,
    actions,
    mutations
}
